import {routes as bibareaconhecimento} from '../biblioteca/bibareaconhecimento'
import {routes as bibareainteresse} from '../biblioteca/bibareainteresse'
import {routes as bibautor} from '../biblioteca/bibautor'
import {routes as bibclassificacao} from '../biblioteca/bibclassificacao'
import {routes as bibconfiguracao} from '../biblioteca/bibconfiguracao'
import {routes as bibcor} from '../biblioteca/bibcor'
import {routes as bibcutter} from '../biblioteca/bibcutter'
import {routes as bibdocumento} from '../biblioteca/bibdocumento'
import {routes as bibeditora} from '../biblioteca/bibeditora'
import {routes as bibemprestimo} from '../biblioteca/bibemprestimo'
import {routes as bibentidade} from '../biblioteca/bibentidade'
import {routes as bibevento} from '../biblioteca/bibevento'
import {routes as bibexemplar} from '../biblioteca/bibexemplar'
import {routes as bibformaaquisicao} from '../biblioteca/bibformaaquisicao'
import {routes as bibidioma} from '../biblioteca/bibidioma'
import {routes as biblocalizacao} from '../biblioteca/biblocalizacao'
import {routes as biblocalpublicacao} from '../biblioteca/biblocalpublicacao'
import {routes as bibmidia} from '../biblioteca/bibmidia'
import {routes as bibmoeda} from '../biblioteca/bibmoeda'
import {routes as bibmotivobaixa} from '../biblioteca/bibmotivobaixa'
import {routes as bibmotivobloqueio} from '../biblioteca/bibmotivobloqueio'
import {routes as bibmotivodispensamulta} from '../biblioteca/bibmotivodispensamulta'
import {routes as bibpalavrachave} from '../biblioteca/bibpalavrachave'
import {routes as bibreserva} from '../biblioteca/bibreserva'
import {routes as bibtipodocumento} from '../biblioteca/bibtipodocumento'
import {routes as bibsugestaoaquisicao} from '../biblioteca/bibsugestaoaquisicao'
import {routes as bibtipousuario} from '../biblioteca/bibtipousuario'
import {routes as bibusuario} from '../biblioteca/bibusuario'
import {routes as bibrelatorios} from '../biblioteca/relatorios'
import {routes as bibrelatorioemprestimo} from './bibrelatorioemprestimo'
import {routes as bibrelatorioestatistica} from './bibrelatorioestatistica'
export default [
  {
    path: '/biblioteca',
    name: 'Biblioteca',
    description: 'Módulo Biblioteca',
    children: [
      ...bibareaconhecimento,
      ...bibareainteresse,
      ...bibautor,
      ...bibclassificacao,
      ...bibconfiguracao,
      ...bibcor,
      ...bibcutter,
      ...bibdocumento,
      ...bibeditora,
      ...bibemprestimo,
      ...bibentidade,
      ...bibevento,
      ...bibexemplar,
      ...bibformaaquisicao,
      ...bibidioma,
      ...biblocalizacao,
      ...biblocalpublicacao,
      ...bibmidia,
      ...bibmoeda,
      ...bibmotivobaixa,
      ...bibmotivobloqueio,
      ...bibmotivodispensamulta,
      ...bibpalavrachave,
      ...bibreserva,
      ...bibtipodocumento,
      ...bibsugestaoaquisicao,
      ...bibtipousuario,
      ...bibusuario,
      ...bibrelatorios,
      ...bibrelatorioemprestimo,
      ...bibrelatorioestatistica,
     ],
    goesToMenu: true
  }
]
